/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HttpPolicySetModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { HTTPPolicySet } from 'object-types';
import { HTTP_POLICY_SET_ITEM_TOKEN } from '../http-policy-set.tokens';

export type THTTPPolicySetCollection = typeof HTTPPolicySetCollection;

/**
 * @description
 *
 *   HttpPolicySet collection
 *
 * @author Rohit Gaikwad
 */
export class HTTPPolicySetCollection extends Collection {
    public static ajsDependencies = [
        HTTP_POLICY_SET_ITEM_TOKEN,
    ];

    constructor(args = {}) {
        const extendedArgs = {
            ...args,
            objectName: 'httppolicyset',
            objectType: HTTPPolicySet,
            permissionName: AviPermissionResource.PERMISSION_HTTPPOLICYSET,
            windowElement: 'lazy-load',
        };

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_(HTTP_POLICY_SET_ITEM_TOKEN);
    }
}
